import useSWR from 'swr'
import { organizationsApi } from '@/lib/api'
import { OrgMember, OrgInvite } from '@/lib/api'

export const TEAM_SWR_KEYS = {
  members: (orgId: string) => ['org', orgId, 'members'] as const,
  invites: (orgId: string) => ['org', orgId, 'invites'] as const,
}

export function useOrgMembers(orgId: string | undefined) {
  return useSWR<Array<OrgMember>>(
    orgId ? TEAM_SWR_KEYS.members(orgId) : null,
    async () => organizationsApi.getMembers(orgId as string),
    { revalidateOnFocus: false },
  )
}

export function useOrgInvites(orgId: string | undefined) {
  return useSWR<Array<OrgInvite>>(
    orgId ? TEAM_SWR_KEYS.invites(orgId) : null,
    async () => organizationsApi.listInvites(orgId as string),
    { revalidateOnFocus: false },
  )
}
